import { mapMutations, mapActions } from 'vuex'
import GooglePlacesApi from '../lib/googlePlacesApi.js'
import router from '../router/index.js'

var mixins = {
  methods: {
    ...mapMutations('user', [
      'updateUserType'
    ]),
    ...mapMutations('business', [
      'updateBusinessName',
      'updateAddress',
      'updateCity',
      'updateZip',
      'updateState',
      'updateSalesPhoneNumber',
      'updateWebsite',
      'updateBusinessId',
      'addArea'
    ]),
    ...mapActions('business', [
      'createBusiness',
      'syncData'
    ]),
    parseAddressComponents (component, addressComponents) {
      for (var i = 0; i < addressComponents.length; i++) {
        if (addressComponents[i].types.includes(component)) {
          return addressComponents[i].long_name
        }
      }
      return null
    },
    formatAddress (streetNumber, route) {
      var formattedAddress = null
      if (streetNumber && route) {
        formattedAddress = streetNumber + ' ' + route
      } else if (streetNumber && !route) {
        formattedAddress = streetNumber
      } else if (!streetNumber && route) {
        formattedAddress = route
      }
      return formattedAddress
    },
    async claimBusiness (businessId, attributionElement) {
      try {
        var promiseArray = await Promise.all([GooglePlacesApi.googleDetails(attributionElement, businessId),
          this.createBusiness(businessId)])
        var businessDetails = promiseArray[0]
        var addressComponents = businessDetails.address_components
        var streetNumber = this.parseAddressComponents('street_number', addressComponents)
        var route = this.parseAddressComponents('route', addressComponents)
        var city = this.parseAddressComponents('locality', addressComponents)
        var state = this.parseAddressComponents('administrative_area_level_1', addressComponents)
        var zipCode = this.parseAddressComponents('postal_code', addressComponents)
        var website = businessDetails.website ? businessDetails.website : null
        var phoneNumber = businessDetails.international_phone_number ? businessDetails.international_phone_number : null
        var name = businessDetails.name ? businessDetails.name : null
        var formattedAddress = this.formatAddress(streetNumber, route)
        this.updateUserType('business')
        this.updateAddress(formattedAddress)
        this.updateCity(city)
        this.updateState(state)
        this.updateZip(zipCode)
        this.updateWebsite(website)
        this.updateBusinessName(name)
        this.updateBusinessId(businessId)
        this.updateSalesPhoneNumber(phoneNumber)
        router.replace('/profile/business/details/overview')
        await this.syncData()
      } catch (error) {
        console.log(error)
      }
    },
    async businessIsClaimed (businessId) {
      var client = this.$store.getters.getBusinessApigClientFactory
      var params = {id: businessId}
      var pathTemplate = '/publicbusinesses/{id}'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        return true
      } catch (error) {
        return false
      }
    }
  }
}

export default mixins



// WEBPACK FOOTER //
// ./src/components/GlobalMixins.js